import { Skeleton } from "@/components/ui/skeleton";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent } from "@/components/ui/card";

function TechnicianItemSkeleton() {
  return (
    <div className="aero:flex aero:items-center aero:gap-3 aero:p-3 aero:rounded-lg aero:border aero:border-neutral-200">
      <Skeleton className="aero:h-4 aero:w-4 aero:rounded" />
      <Skeleton className="aero:h-9 aero:w-9 aero:rounded-full" />
      <div className="aero:flex aero:flex-col aero:gap-1 aero:flex-1">
        <Skeleton className="aero:h-4 aero:w-32" />
        <Skeleton className="aero:h-3 aero:w-20" />
      </div>
    </div>
  );
}

function GridItemSkeleton() {
  return (
    <div className="aero:p-4 aero:rounded-lg aero:border aero:border-neutral-200">
      <div className="aero:flex aero:items-center aero:gap-3">
        <Skeleton className="aero:h-4 aero:w-4 aero:rounded" />
        <Skeleton className="aero:h-10 aero:w-10 aero:rounded-full" />
        <div className="aero:flex aero:flex-col aero:gap-1">
          <Skeleton className="aero:h-4 aero:w-24" />
          <Skeleton className="aero:h-5 aero:w-16 aero:rounded-full" />
        </div>
      </div>
    </div>
  );
}

export default function AssignmentLoading() {
  return (
    <div className="aero:flex aero:flex-col aero:gap-4 aero:py-4 aero:h-[calc(100vh-120px)] aero:overflow-hidden">
      {/* Page Title Skeleton */}
      <div className="aero:flex aero:items-center aero:gap-3 aero:flex-shrink-0">
        <Skeleton className="aero:w-10 aero:h-10 aero:rounded-lg" />
        <Skeleton className="aero:h-8 aero:w-56" />
      </div>

      {/* Main Card */}
      <Card className="aero:!rounded-lg aero:!border-neutral-300 aero:!p-6 aero:!shadow-none aero:flex-1 aero:min-h-0 aero:flex aero:flex-col">
        <CardContent className="aero:!p-0 aero:flex-1 aero:min-h-0 aero:flex aero:flex-col">
          <div className="aero:grid aero:grid-cols-1 aero:lg:grid-cols-12 aero:gap-6 aero:flex-1 aero:min-h-0">
            {/* Left Section - Assigned Technicians */}
            <div className="aero:lg:col-span-5 aero:flex aero:flex-col aero:gap-4 aero:min-h-0">
              {/* Section Title */}
              <div className="aero:flex aero:items-center aero:gap-3">
                <Skeleton className="aero:w-[3px] aero:h-6 aero:rounded-full" />
                <Skeleton className="aero:h-5 aero:w-40" />
                <Skeleton className="aero:flex-1 aero:h-[1px]" />
              </div>

              {/* Search and Buttons */}
              <div className="aero:flex aero:items-center aero:gap-2">
                <Skeleton className="aero:h-10 aero:flex-1 aero:rounded" />
                <Skeleton className="aero:h-10 aero:w-28 aero:rounded" />
                <Skeleton className="aero:h-10 aero:w-28 aero:rounded" />
              </div>

              {/* Divider */}
              <Skeleton className="aero:h-[1px] aero:w-full" />

              {/* List Items */}
              <ScrollArea className="aero:flex-1 aero:min-h-0">
                <div className="aero:flex aero:flex-col aero:gap-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <TechnicianItemSkeleton key={i} />
                  ))}
                </div>
              </ScrollArea>
            </div>

            {/* Right Section - Available Technicians */}
            <div className="aero:lg:col-span-7 aero:flex aero:flex-col aero:gap-4 aero:min-h-0">
              {/* Section Title */}
              <div className="aero:flex aero:items-center aero:gap-3">
                <Skeleton className="aero:w-[3px] aero:h-6 aero:rounded-full" />
                <Skeleton className="aero:h-5 aero:w-44" />
                <Skeleton className="aero:flex-1 aero:h-[1px]" />
              </div>

              {/* Search and Buttons */}
              <div className="aero:flex aero:items-center aero:gap-2">
                <Skeleton className="aero:h-10 aero:flex-1 aero:rounded" />
                <Skeleton className="aero:h-10 aero:w-28 aero:rounded" />
                <Skeleton className="aero:h-10 aero:w-36 aero:rounded" />
              </div>

              {/* Divider */}
              <Skeleton className="aero:h-[1px] aero:w-full" />

              {/* Tabs */}
              <div className="aero:flex aero:flex-col aero:gap-4 aero:flex-1 aero:min-h-0">
                <Skeleton className="aero:h-10 aero:w-48 aero:rounded-lg" />

                {/* Grid Items */}
                <ScrollArea className="aero:flex-1 aero:min-h-0">
                  <div className="aero:grid aero:grid-cols-2 aero:gap-3">
                    {Array.from({ length: 6 }).map((_, i) => (
                      <GridItemSkeleton key={i} />
                    ))}
                  </div>
                </ScrollArea>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
